import {cart} from '@/app/js/cart'

const VOUCHER_FORM_SELECTOR = '.js-voucher-form'
const INVALID_CLASS = 'invalid'
const voucherFormElement = document.querySelector(VOUCHER_FORM_SELECTOR)
const formInputElements = voucherFormElement?.querySelectorAll('input')

function cleanInputErrors() {
  for (const formInputElement of formInputElements) {
    formInputElement.classList.remove(INVALID_CLASS)
  }
}

function showInputErrors(errors) {
  for (const formInputElement of formInputElements) {
    const name = formInputElement.getAttribute('name')
    if (errors[name]) {
      formInputElement.classList.add(INVALID_CLASS)
    }
  }
}

export function initVoucherForm() {
  if (!voucherFormElement) return
  voucherFormElement.addEventListener('submit', async (event) => {
    event.preventDefault()
    cleanInputErrors()
    const formData = new FormData(voucherFormElement)
    try {
      const res = await cart.addVoucher(formData)
      if (!res) return
      if (res.errors) {
        showInputErrors(res.errors)
      } else if (res.redirectUrl) {
        window.location.href = res.redirectUrl
      }
    } catch (e) {
      console.log(e)
    }
  })
}
